import * as React from "react";
import SliderUnstyled from "@material-ui/lab/SliderUnstyled";
import "./slider.css";

export default function UnstyledSlider(props) {
  return <SliderUnstyled className="CustomSlider" {...props} />;
}
